import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import Typography from "../shared/typography.styles"

export const UpperOverlayStyle = css`
  background-color: var(--tricorn-black);
`

export const ContentContainer = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr;
  padding: 40px 0 96px 0;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    padding: 48px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 88px 0 96px 0;
  }
`

export const SectionTitle = styled.h2`
  ${Typography.mobileTextStyles.MobileHeadingOneSemiBold}
  color: var(--dark-mode-body-grey);
  text-align: center;
  align-self: center;

  grid-column: 2 / -2;
  margin-top: 64px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f2f2f266;

  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingTwoSemiBold}
    margin-top: 48px;
    grid-column: 3 / -3;
    padding-bottom: 16px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
    margin-top: 64px;
    padding-bottom: 32px;
  }
`
